export default __webpack_public_path__ + "static/media/lockscreen-bg.5f5074b5.jpg";